import { useMutation } from "@apollo/client/react";
import { CREATE_NOTIFICATION } from "../../../data/graphQL/mutations/Visitas/createNotificacion";
import toast from 'react-hot-toast';

export const useGetAction = () => {
  const [createNotification, { loading }] = useMutation(CREATE_NOTIFICATION, { fetchPolicy: 'no-cache' });

  const handleCreateNotification = (notification) => {
    toast.promise(createNotification({
      variables: {
        input: {
          idEvaluacion: notification.idEvaluacion,
          idProfesional: notification.idProfesional,
          observacion: notification.observacion
        }
      }
    }), {
      loading: 'Notificando...',
      success: 'Notificación creada correctamente!',
      error: 'Ha ocurrido un error al crear la notificación.'
    });
  };

  return {
    handleCreateNotification,
    loading
  };
};